export const DELIVERY_METHOD = {
    FILES: { value: 'FILES', description: 'ladda upp alla bilagor nu' },
    FILES_AND_MAIL: {
        description:
        'ladda upp några bilagor nu och komplettera med några senare (per post eller ladda upp via kompletteringsformuläret).',
        value: 'FILES_AND_FLYLEAF'},
    MAIL: { value: 'FLYLEAF', description: 'skicka in alla bilagor per post' },
};

export const ALL_DELIVERY_METHODS: { value: string, description: string }[] = [
    DELIVERY_METHOD.FILES,
    DELIVERY_METHOD.MAIL,
    DELIVERY_METHOD.FILES_AND_MAIL,
];
